import { BgcVote, BgcVotingRequest } from '../../../../../shared/models/services-request/bgc-voting.model';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { ValidationMessageComponent } from '../../../../../shared/components/validation-message/validation-message.component';
import { BGC_VOTING_POSITIONS, BgcVotingPosition } from './bgc-voting.data';

@Component({
  selector: 'app-bgc-voting',
  imports: [ReactiveFormsModule, TranslateModule, ButtonComponent, ValidationMessageComponent],
  templateUrl: './bgc-voting.component.html'
})
export class BgcVotingComponent implements OnInit {
  groupName = 'Agri Trading Business Group';
  groupId = '';
  email = '';
  srNumber = '';
  expiryDate:any;
  deadline: any;
  positions: BgcVotingPosition[] = [];

  readonly form = new FormGroup({ votes: new FormArray<FormControl<string[]>>([]) });
  pendingSubmission: BgcVotingRequest | null = null;

  constructor(private route: ActivatedRoute, private destroyRef: DestroyRef) {
    this.expiryDate = new Date();
  }

  ngOnInit(): void {
    this.setPositions(BGC_VOTING_POSITIONS);
    this.readInvitationParameters();
  }

  setPositions(positions: BgcVotingPosition[]): void {
    this.positions = positions;
    this.form.controls.votes.clear();
    for (const position of positions) {
      this.form.controls.votes.push(new FormControl<string[]>([], {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(position.maxSelections)]
      }));
    }
  }

  private readInvitationParameters(): void {
    this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.groupId = params.get('groupid') || '';
      this.email = params.get('email') || '';
      this.srNumber = params.get('srnumber') || '';
      this.expiryDate = params.get('expirydate') || new Date();
      this.deadline = '';
      if (this.expiryDate) {
        try { this.deadline = formatDate(this.expiryDate, 'EEEE, dd MMMM yyyy', 'en-US'); }
        catch { /* Link validation will be integrated with the API. */ }
      }
    });
  }

  selectCandidate(index: number, candidateId: string, event: Event): void {
    const position = this.positions[index];
    const control = this.form.controls.votes.at(index);
    const input = event.target as HTMLInputElement;
    if (position.selectionType === 'single') control.setValue([candidateId]);
    else if (!input.checked) control.setValue(control.value.filter(id => id !== candidateId));
    else if (control.value.length < position.maxSelections && !control.value.includes(candidateId)) {
      control.setValue([...control.value, candidateId]);
    } else input.checked = control.value.includes(candidateId);
    control.markAsTouched();
    control.markAsDirty();
  }

  castVote(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid || !this.positions.length) return;
    // API submission and eligibility validation will be added separately.
    const request = new BgcVotingRequest();
    request['Group Id'] = this.groupId;
    request['Email'] = this.email;
    request['SR Number'] = this.srNumber;
    request['Expiry Date'] = this.expiryDate instanceof Date ? this.expiryDate.toISOString() : this.expiryDate ?? '';
    request['Votes'] = this.positions.map((position, index) => {
      const vote = new BgcVote();
      vote['Position Id'] = position.id;
      vote['Position'] = position.position;
      vote['Nominated Person Ids'] = [...this.form.controls.votes.at(index).value];
      return vote;
    });
    this.pendingSubmission = request;

    console.log(this.pendingSubmission)
  }
}
